export const PageBand = ({ title, subtitle, id }) => (
  <section className="bg-charcoal text-white border-b-4 border-brand" data-testid={`${id}-band`}>
    <div className="max-w-[1280px] mx-auto px-6 py-12 sm:py-16">
      <h1 className="font-serif font-bold text-3xl sm:text-4xl lg:text-5xl" data-testid={`${id}-title`}>{title}</h1>
      {subtitle && <p className="mt-3 text-white/70 text-sm sm:text-base max-w-2xl">{subtitle}</p>}
    </div>
  </section>
);
